import { Outlet } from 'react-router-dom'
import Header from '@components/common/Header'
import Footer from '@components/common/Footer'
import { GlobalSEO } from '../components/seo/GlobalSEO'
import { JsonLd } from '../components/seo/JsonLd'
import { organizationSchema, websiteSchema } from '../data/schemaData'

const MainLayout = () => {
  return (
    <div className="main-layout">
      <GlobalSEO />
      <JsonLd data={organizationSchema} />
      <JsonLd data={websiteSchema} />
      <Header />
      <main className="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}

export default MainLayout
